/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: app_analytics_events.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  IngestAppEventsRequest,
  IngestAppEventsResponse,
} from '../types/app_analytics_events';

export const createAppAnalyticsEventsService = (transport: Transport) => ({
  async ingestAppEvents(
    request: IngestAppEventsRequest,
    options: RequestOptions = {},
  ): Promise<IngestAppEventsResponse> {
    const url = getApiPath(API_METHODS.AppAnalyticsEventsService.IngestAppEvents);
    return transport.post<IngestAppEventsResponse>(url, request, options);
  },
});

export type AppAnalyticsEventsService = ReturnType<typeof createAppAnalyticsEventsService>;
